// Os números do campeonato: limites do organizador, dos textos, dos convites e avisos, e o aviso do prêmio. A API
// confere tudo contra eles; os Termos de uso e as telas leem daqui.
export const CAMPEONATOS_ATIVOS_POR_CONTA = 3; // em inscrição ou em andamento
export const NOME_DO_CAMPEONATO_MAX = 40;
export const PREMIO_MAX = 200;
export const MOTIVO_MAX = 200;
export const AVISO_MAX = 140; // mensagem curta do organizador aos inscritos
export const AVISOS_POR_DIA = 3; // por campeonato, dentro do limite de notificações de cada conta
export const CONVITES_POR_DIA = 200; // por campeonato
export const DIAS_POR_RODADA_MIN = 1;
export const DIAS_POR_RODADA_MAX = 30;
export const DIAS_POR_RODADA_PADRAO = 7;
export const INSCRICAO_ATE_MAX_DIAS = 90; // o prazo de inscrição fica até 90 dias à frente
export const TEMPOS_DE_JOGADA_MS = [15_000, 20_000, 30_000, 45_000] as const;
export const ATRASO_DA_TRANSMISSAO_S = 60;
export const AVISO_DO_PREMIO = 'Prêmio oferecido e entregue pelo organizador';
